import { useMutation as c } from "@apollo/client";
import { accountSchema as s } from "../../deserialize/yup/account.js";
import { deserializeData as p } from "../../graphql/deserialize/index.js";
import m from "../../graphql/mutation/loginByOAuth.js";
import { useCallback as l } from "react";
const O = () => {
  const [t, { loading: o }] = c(m);
  return { loginByOAuth: l(
    async (r, a, n, i, u) => {
      const e = await t({
        variables: {
          input: {
            oauthAppType: r,
            network: a,
            isLogin: !0,
            providerInput: {
              authCode: i,
              redirectURI: n
            },
            invitationCode: u
          }
        }
      });
      return p(e, s);
    },
    []
  ), loading: o };
};
export {
  O as default
};
//# sourceMappingURL=useLoginByOAuth.js.map
